import { AuthProvider } from 'react-admin';
import axios from 'axios';
import { TOKEN_URL, CURRENT_USER_URL } from './config';

const authProvider: AuthProvider = {
    // Called when the user attempts to log in
    login: async ({ username, password }) => {
        // Format the data for the OAuth2 token endpoint (form data)
        const formData = new URLSearchParams();
        formData.append('username', username);
        formData.append('password', password);

        try {
            const response = await axios.post(TOKEN_URL, formData, {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                },
            });

            // Store the token in localStorage
            localStorage.setItem('token', response.data.access_token);
            localStorage.setItem('tokenType', response.data.token_type);
            
            // Fetch the user details to get roles
            const userResponse = await axios.get(CURRENT_USER_URL, {
                headers: {
                    'Authorization': `${response.data.token_type} ${response.data.access_token}`
                }
            });
            
            // Store user data
            localStorage.setItem('user', JSON.stringify(userResponse.data));
            
            return Promise.resolve();
        } catch (error) {
            return Promise.reject(error);
        }
    },

    // Called when the user clicks on the logout button
    logout: () => {
        localStorage.removeItem('token');
        localStorage.removeItem('tokenType');
        localStorage.removeItem('user');
        return Promise.resolve();
    },

    // Called when the API returns an error
    checkError: ({ status }) => {
        if (status === 401 || status === 403) {
            localStorage.removeItem('token');
            localStorage.removeItem('tokenType');
            localStorage.removeItem('user');
            return Promise.reject();
        }
        return Promise.resolve();
    },

    // Called when the user navigates to a new location, to check for authentication
    checkAuth: () => {
        return localStorage.getItem('token')
            ? Promise.resolve()
            : Promise.reject();
    },

    // Called when the user navigates to a new location, to check for permissions
    getPermissions: () => {
        const user = JSON.parse(localStorage.getItem('user') || '{}');
        return Promise.resolve(user.is_admin ? 'admin' : 'user');
    },

    // Get the user identity
    getIdentity: () => {
        const user = JSON.parse(localStorage.getItem('user') || '{}');
        return Promise.resolve({
            id: user.id,
            fullName: user.full_name || user.email,
            avatar: undefined,
        });
    }
};

export default authProvider;
